// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import AlibabaOutlinedSvg from "@fishx/icons-svg/es/asn/AlibabaOutlined";
import FishxIcon from '../components/FishxIcon';

var AlibabaOutlined = function AlibabaOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: AlibabaOutlinedSvg
  }));
};

AlibabaOutlined.displayName = 'AlibabaOutlined';
export default React.forwardRef(AlibabaOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/AlibabaOutlined.js
// module id = 1951
// module chunks = 0